/**
 * Question mark component for the parameters of the modules in Home Page.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2025
 */
import { useId } from 'react'
import { BiHelpCircle } from 'react-icons/bi'
import { Tooltip } from 'react-tooltip'
type Props = {
  helpMessage: string
}

export const HomeModuleQuestionMark = ({ helpMessage }: Props) => {
  // Unique local ID for the tooltip
  const tooltipId = useId()

  return (
    <div>
      <BiHelpCircle
        data-tooltip-id={tooltipId}
        data-tooltip-place="bottom"
        width="16px"
        height="16px"
      />
      <Tooltip id={tooltipId} content={helpMessage} className="tooltip" />
    </div>
  )
}
